module.exports = __webpack_public_path__ + "static/media/boba_fett_by_radiusss.8314ee44.svg";